let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6TtDJ")).then(() => parcelRequire('ezu4w'));